module.exports = __webpack_public_path__ + "img/economy.06ac2456.jpg";